import { TFunction } from 'i18next'

import { PaymentReminderDetailsRepeatType } from '../enums/paymentReminderDetailsRepeatType'
import { PaymentRemindersSettings } from '../types/paymentReminders/paymentRemindersSettings'

export const getAutomaticPaymentRemindersDefaultValues = (
  t: TFunction,
  companyName?: string,
): PaymentRemindersSettings => {
  return {
    activationDate: new Date(),
    postAfterDueDate: {
      nDays: 30,
      active: false,
    },
    beforeDueDate: {
      emailSubject: t(
        'settings.organization.external_invoice.automatic_payment_reminders.before_due_date.default_email_subject',
      ),
      emailBody: t(
        'settings.organization.external_invoice.automatic_payment_reminders.before_due_date.default_email_message',
        { companyName },
      ),
      nDays: 1,
      active: false,
    },
    onDueDate: {
      emailSubject: t(
        'settings.organization.external_invoice.automatic_payment_reminders.on_due_date.default_email_subject',
      ),
      emailBody: t(
        'settings.organization.external_invoice.automatic_payment_reminders.on_due_date.default_email_message',
        { companyName },
      ),
      active: false,
    },
    afterDueDate: {
      emailSubject: t(
        'settings.organization.external_invoice.automatic_payment_reminders.after_due_date.default_email_subject',
      ),
      emailBody: t(
        'settings.organization.external_invoice.automatic_payment_reminders.after_due_date.default_email_message',
        { companyName },
      ),
      nDays: 7,
      active: false,
      repeat: PaymentReminderDetailsRepeatType.Once,
    },
  }
}
